export function isValidEmail(email: string) {
  let regEx = /^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/i;
  return regEx.test(String(email).toLowerCase());
}

export function isValidTextNames(names: string) {
  // true if contains any char (2 or more) (including non-english like ü), and not includes numbers nor @£€?!
  let regEx = /^([^@£€?!0-9]+){2,}$/gi;
  return regEx.test(String(names));
}

export function isValidUsername(names: string) {
  // true if contains only digits and word characters (4 or more), and not includes spaces
  let regEx = /^([0-9a-zA-Z]+){4,}$/gi;
  return regEx.test(String(names));
}

export function isValidPassword(text: string) {
  // true if contains at least 8 characters: letters, numbers or special chars (spaces not allowed)
  let regEx = /^[0-9a-zA-Z!?@#$%^&*()\\\-_=+{};:,<.>]{8,}$/gi;
  // true if contains at least 1 lower letter
  let regExHasLowerLetters = /^(?=.*[a-z]).*$/g;
  // true if contains at least 1 upper case letter
  let regExHasUpperLetters = /^(?=.*[A-Z]).*$/g;
  // true if contains at least 1 number
  let regExHasNumbers = /^(?=.*[0-9]).*$/gi;
  const hasSize = regEx.test(String(text));
  const hasLowerLetters = regExHasLowerLetters.test(String(text));
  const hasUpperLetters = regExHasUpperLetters.test(String(text));
  const hasNumbers = regExHasNumbers.test(String(text));

  return hasSize && hasLowerLetters && hasNumbers && hasUpperLetters;
}

export function isValidFile(file: File) {
  // true if file is type .jpg, .jpeg, .png or .pdf
  var regEx = /(\.jpg|\.jpeg|\.png|\.pdf)$/i;
  const isValid = regEx.test(String(file.name));
  return isValid;
}
